export default class MaxRangeModel {
  dayPicker;

  weekPicker;

  monthPicker;

  constructor(dayPicker, weekPicker, monthPicker) {
    this.dayPicker = dayPicker;
    this.weekPicker = weekPicker;
    this.monthPicker = monthPicker;
  }
}
